import {
    type FieldValue,
    type FieldValues,
    FormConfig,
    FieldConfig,
} from '../types'
import { isValidEmail } from './validateEmail'

export type FieldErrorType =
    | 'ERR_REQUIRED'
    | 'ERR_INVALID_EMAIL_ADDRESS'
    | 'ERR_DUPLICATE_REPORT_NAME'

type GetErrorsType = (
    fieldName: string,
    formState: FieldValues,
    formConfig: FormConfig
) => FieldErrorType[]

export type ErrorStrings = Record<FieldErrorType, string>

const isValueEmpty = (fieldValue: FieldValue, _fieldConfig: FieldConfig) => {
    if (typeof fieldValue === 'string') {
        return fieldValue.trim().length === 0
    }

    return false
}

export const getFieldErrors: GetErrorsType = (
    fieldName,
    formState,
    formConfig
) => {
    const errors: FieldErrorType[] = []

    const fieldConfig = formConfig[fieldName]
    const fieldValue = formState[fieldName]

    if (fieldConfig.required && isValueEmpty(fieldValue, fieldConfig)) {
        errors.push('ERR_REQUIRED')
    }

    if (fieldConfig.type === 'email') {
        if (typeof fieldValue === 'string' && fieldValue.length > 0) {
            if (!isValidEmail(fieldValue)) {
                errors.push('ERR_INVALID_EMAIL_ADDRESS')
            }
        }
    }

    return errors
}

export const getFieldsErrors = (
    formConfig: FormConfig,
    formState: FieldValues,
    errorStrings: ErrorStrings
) => {
    const fieldNames = Object.keys(formConfig)

    const fieldsErrors: Record<
        string,
        Record<string, string>
    > = fieldNames.reduce((acc1, fieldName) => {
        const fieldErrors = getFieldErrors(fieldName, formState, formConfig)
        const fieldErrorsStrings: Record<string, string> = fieldErrors.reduce(
            (acc2, errorKey) => {
                return Object.assign({}, acc2, {
                    [errorKey]: errorStrings[errorKey],
                })
            },
            {}
        )

        return Object.assign({}, acc1, {
            [fieldName]: fieldErrorsStrings,
        })
    }, {})

    return fieldsErrors
}
